import React from 'react';
import {
    DrawerContainer,
    StyledDrawer,
    Header,
    Title,
    StyledArrow,
    TitleContainer
} from './Drawer.style';

const Drawer = ({ close, title, isOpen, children, dir, contentStyle = {} }) => {
    return (
        <StyledDrawer
            width="100%"
            styles={{
                bmMenuWrap: {
                    height: '100vh'
                },
                bmOverlay: {
                    top: 0
                }
            }}
            right={dir === 'right'}
            customBurgerIcon={false}
            isOpen={isOpen}
            onClose={close}
            disableAutoFocus
        >
            <Header>
                <StyledArrow onClick={close} />
                <TitleContainer>
                    <Title>{title}</Title>
                </TitleContainer>
            </Header>
            <DrawerContainer style={contentStyle}>{children}</DrawerContainer>
        </StyledDrawer>
    );
};

export { Drawer };
